/**
 * R0.13 — der manuelle Register-Neuabruf, EIN Aufruf fuer beide Orte.
 *
 * Angeboten wird er dort, wo `@maestro/anreicherung` die Handlung `neu_abrufen` zurueckgibt: im
 * Kunden-Profil (`pages/customer-detail.tsx`) und in der Karte „Wer fragt hier an?" im
 * Anfragen-Drawer (`ui/FirmenprofilKarte.tsx`). Beide zeigen dieselbe Zeile — der Schluessel ist
 * der normalisierte Firmenname, nicht die Datensatz-ID —, deshalb reicht EIN Endpunkt mit dem
 * Anker im Koerper.
 *
 * Diese Datei entscheidet NICHTS: ob ein Knopf erscheint, sagt die reine Funktion in
 * `@maestro/anreicherung` (dort getestet, `apps/web` hat keinen Test-Runner). Hier steht nur der
 * Aufruf und die Uebersetzung der drei Ablehnungen in einen Satz, den ein Mensch lesen kann.
 */
import { apiFetch, toApiError, type ApiError } from "./api";

export type NeuabrufAnker = { kundeId: string } | { anfrageId: string };

/**
 * Stoesst den Abruf an. Wirft NICHT — der Aufrufer bekommt entweder `null` (laeuft) oder einen
 * deutschen Satz, den er neben dem Knopf anzeigt.
 *
 * Warum kein `throw`: Die interessanten Faelle sind keine Fehler, sondern Auskuenfte. „Das
 * Stundenlimit ist erreicht, der Abruf ist vorgemerkt" heisst, dass alles richtig gelaufen ist —
 * nur eben nicht jetzt. Als roter Fehlertext gelesen waere das die naechste Anzeige, die etwas
 * Falsches behauptet.
 */
/**
 * R3.2: Derselbe Weg fuer die USt-IdNr.-Bestaetigung. Bewusst ein PARAMETER und keine zweite
 * Funktion: die Mechanik ist identisch (Anker im Koerper, Ablehnungen als Auskunft statt als
 * Fehler), und zwei Kopien waeren zwei Meinungen darueber, was ein 429 bedeutet.
 */
export type NeuabrufZiel = "/api/anreicherung/handelsregister" | "/api/anreicherung/ustid";

export async function neuabrufAnstossen(
  anker: NeuabrufAnker,
  ziel: NeuabrufZiel = "/api/anreicherung/handelsregister",
): Promise<{ ok: boolean; hinweis: string | null }> {
  try {
    const res = await apiFetch(ziel, { method: "POST", body: JSON.stringify(anker) });
    if (res.ok) return { ok: true, hinweis: null };
    const fehler = (await toApiError(res)) as ApiError;
    return { ok: false, hinweis: fehler.message };
  } catch (e) {
    return { ok: false, hinweis: e instanceof Error ? e.message : String(e) };
  }
}
